import * as Types from '../constants/actionTypes';
const defaultState = {
    podetailList: [],
}
export default (state = defaultState, action) => {
    switch (action.type) {
        /* Box Details States */
        case Types.LIST_ALL_PO:
            return {
                ...state,
                podetailList: action.poList
            }
        case Types.PO_DETAIL_DATA:
            return{
                ...state,
                onePodetails : action.onePodetails
        }
        case Types.PO_INFO_COUNT:
            return Object.assign({}, state, { clientPoInfo: action.clientPoInfo})      
        default:
            return state
    }
}
